export const replacePathname = (pathname: string, to: string, from?: string): string => {
  if (from) {
    return pathname.replace(from, to);
  }
  return to;
};
